import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../../Components/Footer/Footer";
const ReturnPolicy = () => {
	return (
		<>
			<Header />
			<div className="min-h-screen bg-gray-50 px-4 py-10 sm:px-6 lg:px-16">
				{/* Container */}
				<div className="mx-auto max-w-5xl bg-white rounded-2xl shadow-md p-6 sm:p-10">

					{/* Title */}
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
						Return Policy
					</h1>

					{/* Breadcrumb */}
					<p className="text-sm text-gray-500 mb-8">
						<Link
							to="/"
							className="hover:text-blue-600 transition-colors"
						>
							Home
						</Link>
						<span className="mx-1">/</span>
						<span className="text-gray-700">Return Policy</span>
					</p>

					{/* Content */}
					<div className="space-y-5 text-gray-700 text-sm sm:text-base leading-relaxed">
						<p>
							We offer refund or exchange within the first{" "}
							<span className="font-semibold">3 days</span> from the date of your
							purchase. If 3 days have passed since your purchase, you will not be
							offered a return, exchange, or refund of any kind.
						</p>

						<p>
							In order to become eligible for a return or an exchange:
						</p>

						<ul className="list-disc pl-6 space-y-2">
							<li>
								The purchased item should be unused and in the same condition as
								you received it.
							</li>
							<li>The item must have its original packaging.</li>
							<li>
								Items purchased on sale may not be eligible for return or exchange.
							</li>
						</ul>

						<p>
							Further, only such items are replaced by us (based on an exchange
							request) if the items are found to be defective or damaged.
						</p>

						<p>
							You agree that there may be certain categories of products or items
							that are exempt from returns or refunds. Such categories will be
							clearly identified to you at the time of purchase.
						</p>

						<p>
							For accepted exchange or return requests, once your returned item is
							received and inspected by us, we will notify you via email about the
							receipt of the returned or exchanged product.
						</p>

						<p>
							If the product passes the quality check at our end, your return or
							exchange request will be processed in accordance with our policies.
						</p>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ReturnPolicy;
